import { create } from 'zustand';
import { DesignModule } from '@app/types';

export const useCurrentModule = create<DesignModule | null>(() => null);
